import { Injectable} from '@angular/core';
import { TenantService } from './tenant.service';

@Injectable({
  providedIn: 'root'
})

export class SseService {

  constructor(private readonly tenant: TenantService) {}

  getEventSource(url: string): EventSource {
    url = url + "&tenantId=" + this.tenant.getCurrentTenant().tenantId;
    return new EventSource(url);
  }

}
